/**
 * Normalize uploaded media URLs for the browser.
 * Local uploads are stored as absolute backend URLs but should load via /uploads proxy.
 */
export function resolveMediaUrl(url) {
  if (!url) return null;
  if (url.startsWith('blob:') || url.startsWith('data:')) return url;
  if (url.startsWith('/uploads')) return url;

  if (url.startsWith('http://') || url.startsWith('https://')) {
    try {
      const { pathname } = new URL(url);
      if (pathname.startsWith('/uploads')) return pathname;
    } catch (_) {
      // fall through
    }

    const uploadsIndex = url.indexOf('/uploads/');
    if (uploadsIndex !== -1) return url.slice(uploadsIndex);
    return url;
  }

  return url;
}
